import React from 'react'

import VScroll from '../../../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll'

import {templatesLibrary} from '../../../config/library'
import {NewProject_SelectedType} from "../../../new-project-main";

type Props = {
    categoryId  : ID

    onSelect    : func
}

export default class TemplatesListLibrary extends React.Component<Props> {

    onSelectType = (type: any, id: ID) =>  {
        this.props.onSelect(type, id)
    }

    /*onManageProjectTypes = () => {
        gd.goTo('/settings/templates')
    }*/

    render() {
        const {categoryId} = this.props
        let category: any = _.find(templatesLibrary,c=>c.id === categoryId)

        const usedTemplates = _.chain(gd.session.templatesList.models)
            .filter(t=>t.companyId === gd.companyId && !t.isDeleted && !!t.sharedTemplateId)
            .map(t=>t.sharedTemplateId)
            .value()

        return (
            <VScroll className="templates-library-list">
                {_.map(category?.items, (t: any, key: number)=> {
                    const isAlreadyUsed = usedTemplates.includes(t.id)

                    const onClick = ()=>{
                        const type = isAlreadyUsed ? NewProject_SelectedType.SHARED_REDIRECTED : NewProject_SelectedType.SHARED
                        const id = t.id;
                        this.onSelectType(type, id)
                    }

                    return (
                        <div key={key} className="tpl-library img" onClick={onClick}>
                            <img className="option-image" src={t.img} />
                            <div className="option-title">{t.name}</div>
                            <div className="option-description">{t.description}</div>

                            {/*{isAlreadyUsed && <div className="used-icon i5-star"> </div>}*/}
                            <div className="cf"> </div>
                        </div>
                    )
                })}
            </VScroll>
        )
    }
}